<template>
    <article class="press-release-content">
        <div class="max-w-none mb-8">
            <Heading :level="1" color="text-gray-900" class="text-ash-200 capitalize">
                {{ title }}
            </Heading>
            <div class="mt-[3.5714285714rem] md:pr-[3.5714285714rem]">
                <div v-if="image" class="mb-8 relative w-full h-[12.86rem] lg:h-[39.0714286rem] overflow-hidden">
                    <BackgroundImage :image="image" :label="imageAlt || 'Press release image'" />
                </div>
                <div class="press-release-body text-[1rem] leading-[1.71428571rem] text-ash-100">
                    <div v-html="content"></div>
                </div>
                <Contact />
            </div>
        </div>
    </article>
</template>

<script setup lang="ts">
import Heading from '../../atom/heading.vue'
import BackgroundImage from '../../atom/backgroundImage.vue'
import Contact from '../../organism/press-releases/contact.vue'
import type { PressReleasesContentProps } from '~~/shared/types/common'

withDefaults(defineProps<PressReleasesContentProps>(), {
    title: '',
    image: '',
    imageAlt: '',
    content: '',
})
</script>

<style scoped>
.press-release-content :deep(.press-release-body) {
    font-family: inherit;
}

.press-release-content :deep(.press-release-body p) {
    margin-bottom: 1rem;
    font-weight: normal;
}

.press-release-content :deep(.press-release-body strong) {
    font-weight: 700;
}

.press-release-content :deep(.press-release-body em) {
    font-style: italic;
}

.press-release-content :deep(.press-release-body a) {
    color: #000000;
    text-decoration: underline;
}

.press-release-content :deep(.press-release-body ul) {
    padding-left: 1.5rem;
    list-style-type: disc;
}

.press-release-content :deep(.press-release-body ol) {
    padding-left: 1.5rem;
    list-style-type: decimal;
}

.press-release-content :deep(.press-release-body li) {
    font-weight: normal;
    display: list-item;
}

.press-release-content :deep(.press-release-body h1),
.press-release-content :deep(.press-release-body h2),
.press-release-content :deep(.press-release-body h3),
.press-release-content :deep(.press-release-body h4),
.press-release-content :deep(.press-release-body h5),
.press-release-content :deep(.press-release-body h6) {
    font-weight: 600;
}

/* Ensure proper spacing for nested elements */
.press-release-content :deep(.press-release-body > *:first-child) {
    margin-top: 0;
}

.press-release-content :deep(.press-release-body > *:last-child) {
    margin-bottom: 0;
}
</style>
